import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  TextArea,
} from "../../common/Style";
import { useForm } from "react-hook-form";
import { CFV } from "../../common/others/Functions";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { deleteF, edit } from "../../../store/reducers/todosReducer";
import GCalendar from "../../common/calendar/Calendar";
import GenericModal from "../../common/modals/GenericModal";
import trash from "../../../assets/common/trash.svg";
import YesNoModal from "../../common/modals/YesNoModal";

const Edit = ({ todo, init }) => {
  const dispatch = useDispatch();
  const { todosLoading } = useSelector((state) => state.todosReducer);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [showCalendar, setShowCalendar] = useState(null);
  const [showDelete, setShowDelete] = useState(null);

  const [date, setDate] = useState(new Date(todo.executionDate));

  const handleSetDate = (e) => {
    let date1 = e;
    date1.setHours(20);
    setDate(date1);
  };

  const onSubmit = async (data) => {
    const body = { ...data, executionDate: date.toISOString() };
    dispatch(edit(todo._id, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  const handleDelete = () => {
    dispatch(deleteF(todo._id)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label>כותרת</Label>
        <Input
          defaultValue={todo.title}
          type="text"
          {...register("title", {
            required: true,
            minLength: 2,
            maxLength: 50,
          })}
        />
        {CFV("title", "בין 2 ל 50 תווים", errors)}

        <Label>הערות</Label>
        <TextArea
          defaultValue={todo.description}
          type="text"
          rows="3"
          {...register("description", {
            minLength: 0,
            maxLength: 500,
          })}
        />
        {CFV("description", "עד 500 תווים", errors)}

        <Label>תאריך לביצוע</Label>
        <Input
          onClick={() => setShowCalendar(true)}
          value={date
            .toISOString()
            .replace(/T.*/, "")
            .split("-")
            .reverse()
            .join("/")}
          onChange={() => {}}
          type={"text"}
        />
        <FlexRowBetween style={{ marginTop: "50px" }}>
          <Button style={{ width: "100%" }}>שמירה</Button>
          <GenericDiv
            onClick={() => setShowDelete(true)}
            background={"rgba(41,59,90,0.95)"}
            style={{ marginRight: "20px", padding: "9px 10px" }}
          >
            <img src={trash} alt="trash" style={{ width: "21px" }} />
          </GenericDiv>
        </FlexRowBetween>
      </div>

      {todosLoading && <OpacityLoading />}

      {showCalendar && (
        <GenericModal
          init={setShowCalendar}
          div={
            <GCalendar
              setDate={handleSetDate}
              date={date}
              init={setShowCalendar}
            />
          }
        />
      )}

      {showDelete && (
        <GenericModal
          init={setShowDelete}
          div={
            <YesNoModal
              title={"מחיקת משימה"}
              body={"האם את/ה בטוח/ה שברצונך למחוק משימה זו?"}
              no={setShowDelete}
              yes={handleDelete}
            />
          }
        />
      )}
    </PopupForm>
  );
};

export default Edit;
